export const AIStatus = Object.freeze({
  typing: "Typing",
  standby: "Standby",
  generatingImage: "ImageGenerating",
});

export const toAIStatus = (value) => {
  const key = value.toLowerCase();
  return AIStatus[key] || value;
};
